/* Publish by EComposer at 2024-07-12 12:35:11*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-rx5gjij0zeg"]=  window.__ectimmers["ecom-rx5gjij0zeg"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-rx5gjij0zeg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rx5gjij0zeg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rfgni4cloz7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rfgni4cloz7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b1srdgroa5t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b1srdgroa5t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gqxw1lfe4th').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gqxw1lfe4th', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wzedy8m4iho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wzedy8m4iho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qsgy67ahn4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qsgy67ahn4j', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4h072t5r48c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4h072t5r48c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5zps6agwv9u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5zps6agwv9u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sky01fg1xh8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sky01fg1xh8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-idzc44bvbvf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-idzc44bvbvf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hpf0pknkoh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hpf0pknkoh6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-exz3ykk9vo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-exz3ykk9vo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k2f34tzmpa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k2f34tzmpa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ux7lol255k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ux7lol255k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4v4umy6hff3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4v4umy6hff3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-msbf04thqt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-msbf04thqt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qqs5zier8le').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qqs5zier8le', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-urf44z0xwv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-urf44z0xwv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oiks75vvh6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oiks75vvh6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vyt09axriip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vyt09axriip', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vhwmsxg6wrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vhwmsxg6wrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d12rj92txe7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d12rj92txe7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-am5hzb0cjbh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-am5hzb0cjbh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vg8jqo7ptc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vg8jqo7ptc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jt4sgmttyhk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jt4sgmttyhk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xz3rsxnq4qs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xz3rsxnq4qs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4kg99z9265g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4kg99z9265g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hrbha0tjnm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hrbha0tjnm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6dk69icrq79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6dk69icrq79', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ry1ze1ogbwd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ry1ze1ogbwd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dd9z4udclap').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dd9z4udclap', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5qdc9qnbx05').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5qdc9qnbx05', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gp0ze0eozfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gp0ze0eozfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w40znbgulwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w40znbgulwa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hgzbqdx61hi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hgzbqdx61hi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-657yj8909xx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-657yj8909xx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ay9q2ovwxzu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ay9q2ovwxzu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6no2z3d1o9x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6no2z3d1o9x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pu320xydkl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pu320xydkl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oyrxcgwnjhd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oyrxcgwnjhd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rev69dncv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rev69dncv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ywopjsbpwlh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ywopjsbpwlh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a745gmwqgoq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a745gmwqgoq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-52lgsvmzxqs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-52lgsvmzxqs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fxmermtmnh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fxmermtmnh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3yjrjwg76').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3yjrjwg76', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-60qjizsxmb5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-60qjizsxmb5', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-otseropsr8e"]=  window.__ectimmers["ecom-otseropsr8e"] || {};
var g,f,b,h,m;let e=this.$el;if(!e)return;let i=this.isLive;const t=(g=this.settings.disable_auto_close)!=null?g:!1,n=(f=this.settings.disable_auto_close__tablet)!=null?f:!1,s=(b=this.settings.disable_auto_close__mobile)!=null?b:!1,o=(h=this.settings.scroll_on_mobile)!=null?h:!1,a=(m=this.settings.disable_effect)!=null?m:!1,r=e.querySelectorAll(".ecom-accordion__item > .ecom-accordion__title");function c(v){const y=v.getBoundingClientRect();return y.top>=0&&y.left>=0&&y.bottom<=(window.innerHeight||document.documentElement.clientHeight)&&y.right<=(window.innerWidth||document.documentElement.clientWidth)}function u(v){let y=window.screen.width;window.EComposer.TEMPLATE_ID||(y=window.innerWidth),v.forEach((w,C)=>{let $=w.parentNode.querySelector(".ecom-accordion__body");!a&&$&&$.classList.add("ecom-effect-accodion"),w.onclick=function(M){M.preventDefault();let L=this.parentNode,S=L.parentNode;const T=S.querySelectorAll(".ecom-accordion__item"),q=S.querySelectorAll(".ecom-accordion__title");if(this.classList&&this.classList.contains("ecom-item-active"))s&&y<768||n&&y>767&&y<1025||t&&y>1024?(this.classList.remove("ecom-item-active"),L.querySelector(".ecom-accordion__body").style.height="0px",L.querySelector(".ecom-accordion__title").classList.remove("ecom-item-active"),L.classList.remove("ecom-item-active")):(T.forEach(P=>l(P)),q.forEach(P=>P.classList.remove("ecom-item-active")));else{s&&y<768||n&&y>767&&y<1025||t&&y>1024||(T.forEach(W=>l(W)),q.forEach(W=>W.classList.remove("ecom-item-active"))),w.classList.add("ecom-item-active"),L.classList.add("ecom-item-active");let P=w.parentNode.querySelector(".ecom-accordion__body");w.parentNode.closest(".ecom-accordion__body")&&(w.parentNode.closest(".ecom-accordion__body").style.height="auto"),P.style.height="auto";let V="auto";a||(V=i?P.clientHeight+"px":"auto",P.classList.add("ecom-effect-accodion")),P.style.height="0px",setTimeout(()=>{P.style.height=V},10)}window.dispatchEvent(new window.Event("renderScroll")),setTimeout(()=>{window.dispatchEvent(new window.Event("renderScroll")),o?c(this)||I():!c(this)&&y>1024&&I()},500);function A(P){let V=0;if(P.offsetParent){do V+=P.offsetTop;while(P=P.offsetParent);return[V]}}function I(P){window.scroll(0,A(e)-100)}}})}function l(v){v.classList.remove("ecom-item-active"),v.querySelector(".ecom-accordion__body").style.height="0"}u(r),window.addEventListener("resize",function(){u(r)})

                    });
                    
                        document.querySelectorAll('.ecom-otseropsr8e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-otseropsr8e', settings: {"disable_auto_close":false,"disable_effect":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y6242y3khkf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y6242y3khkf', settings: {"disable_auto_close":false,"disable_effect":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vhrgybslm1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vhrgybslm1', settings: {"disable_auto_close":false,"disable_effect":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a3ablmcz43l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a3ablmcz43l', settings: {"disable_auto_close":false,"disable_effect":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}